import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/out_25.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image120.webp';
import slideImg2 from '../images/image36.webp';
import slideImg3 from '../images/image97_.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const fruitvilleConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Fruitville Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Fruitville, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_fruitville',

 /* ── Hero ───────────────────────────────────────────────────────────────── */ 
  heroHeading: 'Serving Fruitville',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Fruitville Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring professional grade tree care to 
     homeowners and businesses across <strong>Fruitville</strong>. The mix of residential 
     neighborhoods and open land in this area means trees grow large and fast and without 
     proper maintenance, they become serious risks to roofs, fences, vehicles, and utility 
     lines. Our team handles the jobs that require real skill and the right equipment.`,

    `We specialize in <strong>dangerous tree situations</strong> storm split limbs, 
     fast growing canopies overtaking structures, trees leaning from root damage, and 
     overgrowth that creates storm vulnerability. Whether it's a full removal or strategic 
     pruning, we get it done safely and cleanly.`,

    `<strong>Sam's Tree Service</strong> provides expert, affordable tree care throughout 
     <strong>Fruitville</strong> and the surrounding <strong>East Sarasota</strong> 
     corridor protecting your property and keeping your landscape in great shape all year.`,
  ],

  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Fruitville, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Fruitville = () => <LocationPage config={fruitvilleConfig} />;
export default Services_Fruitville;
